import React, { useEffect, useState } from 'react'
import env from './../../../environments/environment'
import { observer } from 'mobx-react-lite'
import { MDBCollapse, MDBCol, MDBIcon } from 'mdb-react-ui-kit'
import UserProfileService from './../../../shared/services/UserProfile.service'
import { ContactManager, CrmStore } from './../../../components/crm' // LocationSelector,
import MaxAvAgeAlert from './MaxAvAgeAlert/MaxAvAgeAlert.component'
import ClientForm from './ClientForm/ClientForm.component'
import AvPoliciesList from './AvPoliciesList/AvPoliciesList.component'
import PolicySubmitter from './PolicySubmitter/PolicySubmitter.component'
import SalesTrackerStore from './../store'

const ENABLE_CRM = env.integrations?.bm10x?.enable === true

const doesUserHaveLocations = async source => {
  if (ENABLE_CRM) {
    try {
      const User = await UserProfileService.instance(),
        metaValue = JSON.parse(
          ((await User.meta(true).key('10x---location-id')) || []).shift()?.get('meta_value') || '{}'
        )
      return !!metaValue?.[source] && metaValue?.[source]
    } catch (error) {
      return false
    }
  }

  return false
}

export default observer(({ Policy, reset }) => {
  const policyId = Policy && Policy?.id(),
    policyContactId = (Policy && Policy?.get('contact_id')) || false,
    [locationId, setLocationId] = useState(null),
    [skipIntegration, setSkipIntegration] = useState(false),
    { Contact } = CrmStore

  // Initialize location check
  useEffect(() => {
    const checkLocation = async () => {
      try {
        const lId = await doesUserHaveLocations('sales')
        if (lId === false) {
          setSkipIntegration(true)
        }
        setLocationId(lId)
      } catch (error) {
        setSkipIntegration(true)
        setLocationId(null)
      }
    }

    if (locationId === null) {
      checkLocation()
    }
  }, [locationId])

  const isCrmUsePermitted = () => !UserProfileService.isA(['affiliate-group', 'associate-group']),
    isCrmValid = !!(isCrmUsePermitted() && CrmStore.Contact && CrmStore.isAssigned)

  const renderContactManager = () => {
    if (isCrmUsePermitted() && !skipIntegration && ENABLE_CRM) {
      return (
        <>
          <ContactManager locationId={locationId} />
          {!isCrmValid ? (
            <MDBCol size='12'>
              <button className='skip-crm-btn' onClick={() => setSkipIntegration(true)}>
                Skip integration for now&nbsp;
                <MDBIcon fas icon='arrow-right' />
              </button>
            </MDBCol>
          ) : (
            <></>
          )}
          <br />
        </>
      )
    }
    return null
  }

  useEffect(() => {
    if (policyId && !policyContactId && !skipIntegration) {
      setSkipIntegration(true)
    }
  }, [policyId, policyContactId, skipIntegration])

  return (
    <div id='SalesTrackerComponent'>
      {renderContactManager()}
      <MDBCollapse open={!ENABLE_CRM || isCrmValid || skipIntegration}>
        <MaxAvAgeAlert />
        <ClientForm Contact={Contact} />
        <AvPoliciesList />
        <br />
        <PolicySubmitter
          goTo={() => {
            reset()
            setSkipIntegration(false)
            SalesTrackerStore.setClientType('individual')
            SalesTrackerStore.fetchById(null)
          }}
        />
      </MDBCollapse>
    </div>
  )
})
